import { render, staticRenderFns } from "./BaseInputChosen.vue?vue&type=template&id=4d5004e3&"
import script from "./BaseInputChosen.vue?vue&type=script&lang=js&"
export * from "./BaseInputChosen.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputChosen.vue?vue&type=style&index=0&id=4d5004e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports